export function shutdownZendesk(): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (typeof (window as any).zE === 'function') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).zE('messenger', 'logoutUser');
  }
}
